import { IconProps, Layer } from "iconsax-react";

const WorkspacesIcon = (props: IconProps) => <Layer size={16} {...props} />

export default  WorkspacesIcon;
